import { AssociadoAuthLocalStorageNames } from './../enuns/AssociadoAuthLocalStorageNames';

export const getAssociadoLocalStorageAccessToken = (): string | null => {
  const token: string | null = window.localStorage.getItem(AssociadoAuthLocalStorageNames.AccessToken);
  return token ? `Bearer ${token}` : null;
}